// extracted by mini-css-extract-plugin
export var cartIcon = "_l6-0";
export var cartIconContainer = "_l6-1";